import React from 'react'
import {clearAll} from "../../api/storageApi";
import {NavLink} from "react-router-dom";

const Header = ({logOutMe}) => {
    const logOutUser= ()=>{
        clearAll()
        logOutMe()

        window.location.reload();
    }
    return (
        <div>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#">
                            <i className="fas fa-bars"/></a>
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <NavLink to={'Home'} className="nav-link">Ana Səhifə</NavLink>
                    </li>
                </ul>
                {/* SEARCH FORM */}
                <form className="form-inline ml-3">
                    <div className="input-group input-group-sm">
                        <input className="form-control form-control-navbar" type="search" placeholder="Axtarış et"
                               aria-label="Search"/>
                        <div className="input-group-append">
                            <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"/>
                            </button>
                        </div>
                    </div>
                </form>
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a className="nav-link"
                           style={{cursor: 'pointer'}}
                           data-widget="control-sidebar"
                           data-slide="true"
                           onClick={logOutUser}>
                            <i className="fas fa-power-off"/>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Header;
